import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "homepageLogged" }
const _hoisted_2 = { class: "mainContent flex wp1200" }
const _hoisted_3 = { class: "col2_3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "col1_3" }
const _hoisted_6 = { class: "shortcuts" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.feed.data.length === 0)
          ? (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(_ctx.$t("feed.empty")), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_InfinityScroll, {
          onLoadNextPage: _ctx.loadFeed,
          loading: _ctx.isLoading,
          data: _ctx.feed,
          class: "browser-infinity-scroll",
          "dont-use-mobile-handler": true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feed.data, (item) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentName(item.type.name)), {
                key: item.id,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["onLoadNextPage", "loading", "data"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("feed.shortcuts")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("navigation_list.mobility")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_7,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ParkingMap' })))
            }, _toDisplayString(_ctx.$t("navigation_list.parkings")), 1)
          ]),
          (_ctx.bikesEnabled)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'BikesMap' })))
                }, _toDisplayString(_ctx.$t("navigation_list.bike_sharing")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _hoisted_10,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'FindPath' })))
            }, _toDisplayString(_ctx.$t("navigation_list.transport")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_11,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'TrafficInfoMap' })))
            }, _toDisplayString(_ctx.$t("navigation_list.traffic")), 1)
          ]),
          (_ctx.sharedMobilityEnabled)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'SharedMobilityMap' })))
                }, _toDisplayString(_ctx.$t("navigation_list.shared_mobility")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("navigation_list.news_events")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_14,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'News' })))
            }, _toDisplayString(_ctx.$t("navigation_list.news")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_15,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'Events' })))
            }, _toDisplayString(_ctx.$t("navigation_list.events")), 1)
          ])
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("navigation_list.environment")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_16,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'Weather' })))
            }, _toDisplayString(_ctx.$t("navigation_list.weather")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_17,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push({ name: 'AirQuality' })))
            }, _toDisplayString(_ctx.$t("navigation_list.aqi")), 1)
          ])
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("navigation_list.community")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_18,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (
                _ctx.$router.push({
                  name: _ctx.$store.getters['user/isLoggedIn'] ? 'Active' : 'Public',
                })
              ))
            }, _toDisplayString(_ctx.$t("navigation_list.surveys")), 1)
          ])
        ])
      ])
    ])
  ]))
}